import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";

export const notificationsReportingApi = createApi({
  reducerPath: "notificationsApi",
  tagTypes: ["NewNotifications", "MyNotifications"],
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getNewNotifications: builder.query({
      query: ({ clientName }) => ({
        url: "/notifications/new_notifications",
        method: "GET",
        params: {
          client_name: clientName,
        },
      }),
      providesTags: ["NewNotifications"],
      // You probably don't want to invalidate here — only mutations should invalidate
    }),

    getMyNotifications: builder.query({
      query: ({ clientName }) => ({
        url: "/notifications/my_notifications",
        method: "GET",
        params: {
          client_name: clientName,
        },
      }),
      providesTags: ["MyNotifications"],
    }),

    addANotification: builder.mutation({
      query: ({
        clientName,
        notificationTitle,
        notificationMessage,
        notificationDeliverUntil,
        notificationType,
      }) => ({
        url: "/notifications/notification",
        method: "PUT",
        body: {
          client_name: clientName,
          notification: {
            title: notificationTitle,
            message: notificationMessage,
            deliver_until: notificationDeliverUntil,
            type: notificationType,
          },
        },
      }),
      invalidatesTags: ["NewNotifications", "MyNotifications"],
    }),

    dismissNotification: builder.mutation({
      query: ({
        clientName,
        notificationTitle,
        notificationMessage,
        notificationDeliverUntil,
        notificationType,
      }) => ({
        url: "/notifications/dismiss_notification",
        method: "POST",
        body: {
          client_name: clientName,
          notification: {
            title: notificationTitle,
            message: notificationMessage,
            deliver_until: notificationDeliverUntil,
            type: notificationType,
          },
        },
      }),
      invalidatesTags: ["MyNotifications"],
    }),
  }),
});

export const {
  useGetNewNotificationsQuery,
  useGetMyNotificationsQuery,
  useAddANotificationMutation,
  useDismissNotificationMutation,
} = notificationsReportingApi;

export default notificationsReportingApi.reducer;
